const LOGIN = 'LOGIN'
const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
const LOGIN_ERROR = 'LOGIN_ERROR'
const LOGOUT = 'LOGOUT'
const CHANGE_PASSWORD = 'CHANGE_PASSWORD'
const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS'
const CHANGE_PASSWORD_ERROR = 'CHANGE_PASSWORD_ERROR'
const SET_IS_TRW = 'SET_IS_TRW'

export default {
  namespaced: true,
  state: {
    user: localStorage.getItem('user'),
    authenticated: !!localStorage.getItem('token') || !!localStorage.getItem('tokenJwt'),
    token: localStorage.getItem('token'),
    tokenJwt: localStorage.getItem('tokenJwt'),
    refresh: localStorage.getItem('refresh'),
    company: localStorage.getItem('company'),
    userData: {},

    // Shipping
    admin: {id: 5, prohibitions: []},
    office: {id: 1, prohibitions: ['createMasters']},
    warehouseResp: {id: 2, prohibitions: ['createMasters', 'seeHistory', 'seeTasklist']},
    forklift: {id: 6, prohibitions: ['createMasters', 'addExp', 'addRecep', 'addTruck', 'editTruck', 'seeHistory', 'justCompanyNotes', 'isForkLift', 'seeTasklist']},
    kiosk: {id: 4, prohibitions: ['createMasters', 'addExp', 'addRecep', 'addTruck', 'editExp', 'editRecep', 'editTruck', 'seeFilters', 'seeHistory', 'editStatus', 'editReasons', 'seeTasklist']},
    client: {id: 3, prohibitions: ['createMasters', 'addExp', 'addRecep', 'addTruck', 'seeHistory', 'editStatus', 'editReasons', 'justClientNotes', 'seeTasklist']},
    truckAccess: {id: 10, prohibitions: ['createMasters', 'addExp', 'addRecep', 'seeHistory', 'editStatus', 'editReasons', 'justClientNotes', 'seeFilters', 'editTruck', 'editExp', 'editRecep', 'seeTasklist']},

    // TRW
    adminTrw: { id: 5, prohibitions: ['lockdowns'] },
    officeTrw: { id: 1, prohibitions: ['createMasters', 'deleteExp', 'deleteRecep'] },
    warehouseRespTrw: { id: 2, prohibitions: ['createMasters', 'seeHistory', 'deleteExp', 'deleteRecep', 'seeTasklist'] },
    forkliftTrw: { id: 6, prohibitions: ['lockdowns', 'createMasters', 'addExp', 'addRecep', 'addTruck', 'editTruck', 'seeHistory', 'justCompanyNotes', 'isForkLift', 'deleteExp', 'deleteRecep', 'seeTasklist'] },
    kioskTrw: { id: 4, prohibitions: ['lockdowns', 'createMasters', 'addExp', 'addCL', 'addRecep', 'addTruck', 'editExp', 'editRecep', 'editTruck', 'seeFilters', 'isKiosk', 'seeHistory', 'editStatus', 'editReasons', 'deleteExp', 'deleteRecep', 'seeTasklist'] },
    clientTrw: { id: 3, prohibitions: ['lockdowns', 'createMasters', 'addExp', 'addRecep', 'addTruck', 'seeHistory', 'editStatus', 'editReasons', 'justClientNotes', 'deleteExp', 'deleteRecep', 'seeTasklist'] },
    truckAccessTrw: { id: 14, prohibitions: ['createMasters', 'addExp', 'addRecep', 'seeHistory', 'editStatus', 'editReasons', 'justClientNotes', 'seeFilters', 'editTruck', 'editExp', 'editRecep', 'seeTasklist'] },

    ReadOnly: { id: 11, prohibitions: ['lockdowns', 'createMasters', 'addExp', 'addCL', 'addRecep', 'addTruck', 'editExp', 'editRecep', 'editTruck', 'seeFilters', 'isKiosk', 'seeHistory', 'editStatus', 'editReasons', 'deleteExp', 'deleteRecep', 'seeTasklist'] },
    guardia: { id: 10, prohibitions: ['lockdowns', 'createMasters', 'addExp', 'addRecep', 'editExp', 'editRecep', 'seeHistory', 'editStatus', 'editReasons', 'deleteExp', 'deleteRecep', 'seeTasklist', 'seeDashboard', 'seeExpeditions', 'seeReceptions', 'seeBi'] },
    carretilleros: { id: 9, prohibitions: ['lockdowns', 'createMasters', 'addExp', 'addRecep', 'addTruck', 'editTruck', 'seeHistory', 'onlyTruckHours', 'deleteExp', 'deleteRecep', 'seeTasklist'] },
    oficinaJuanCarlos: { id: 8, prohibitions: ['createMasters', 'addTruck', 'editTruck'] },
    plannerTrw: { id: 7, prohibitions: ['lockdowns', 'createMasters', 'deleteExp', 'deleteRecep', 'addTruck', 'editTruck', 'mrpLimitations', 'seeTasklist', 'seeDashboard', 'seeTrucks', 'seeBi'] },
    kioskReceptions: { id: 13, prohibitions: ['lockdowns', 'createMasters', 'addExp', 'addCL', 'addRecep', 'addTruck', 'editExp', 'editRecep', 'editTruck', 'seeFilters', 'isKiosk', 'seeHistory', 'editStatus', 'editReasons', 'deleteExp', 'deleteRecep', 'seeTasklist'] },
    provider: { id: 12, prohibitions: ['lockdowns', 'createMasters', 'addExp', 'addCL', 'addTruck', 'editExp', 'editTruck', 'seeOriginFilter', 'seeHistory', 'editStatus', 'editReasons', 'deleteExp', 'deleteRecep', 'repeatReceptions', 'seeTasklist', 'seeDashboard', 'seeExpeditions', 'seeTrucks', 'seeBi'] }
  },
  mutations: {
    [LOGIN] (state) {
      state.do_login = true
    },
    [LOGIN_SUCCESS] (state) {
      state.authenticated = true
      state.do_login = false
    },
    [LOGIN_ERROR] (state) {
      state.do_login = false
    },
    [LOGOUT] (state) {
      state.authenticated = false
    },
    [CHANGE_PASSWORD] (state) {
      state.do_change_password = true
    },
    [CHANGE_PASSWORD_SUCCESS] (state) {
      state.do_change_password = false
    },
    [CHANGE_PASSWORD_ERROR] (state) {
      state.do_change_password = false
    },
    [SET_IS_TRW] (state, isTrw) {
      state.isTrw = isTrw
    }
  },
  actions: {
    login ({ commit, state, getters, rootState }, creds) {
      return this.dispatch('request', { method: 'post', url: 'get-token', data: creds })
        .then(
          response => {
            localStorage.setItem('user', creds.username)
            state.user = creds.username
            localStorage.setItem('token', response.data.token)
            state.token = response.data.token
            commit(LOGIN_SUCCESS)
            return response
          }
        ).catch(error => {
          commit(LOGIN_ERROR)
          throw error
        })
    },
    setJwtToken ({ commit, state, getters, rootState }, creds) {
      state.tokenJwt = creds.tokenJwt
      state.refresh = creds.refresh
      state.authenticated = true
    },
    company ({ commit, state }, company) {
      localStorage.setItem('company', company)
      state.company = company
    },
    logout ({ commit, state }) {
      localStorage.removeItem('user')
      localStorage.removeItem('token')
      localStorage.removeItem('tokenJwt')
      localStorage.removeItem('refresh')
      localStorage.removeItem('group')
      localStorage.removeItem('company')
      state.userData = {}
      commit(LOGOUT)
    },
    changePassword ({ commit, state, getters, rootState }, oldNew1New2Passwd) {
      commit(CHANGE_PASSWORD)
      return this.dispatch('request', { method: 'post', url: `api/user/${state.userData.user.id}/change_password`, data: oldNew1New2Passwd })
        .then(
          response => {
            rootState.notification = {
              group: 'global',
              duration: 4000,
              type: 'success',
              title: 'Change password',
              text: 'Sucessfully saved new password'
            }
            commit(CHANGE_PASSWORD_SUCCESS)
            return response
          }
        ).catch(error => {
          // commit(CHANGE_PASSWORD_ERROR)
          throw error
        })
    },
    logoutSso ({ commit, state }) {
      if (state.authenticated) {
        return this.dispatch('request', { method: 'get', url: 'sso/logout' })
          .then(
            response => {
              return response
            }
          ).catch(error => {
            throw error
          })
      }
    },
    refreshSso ({ commit, state, getters, rootState }, creds) {
      if (state.authenticated) {
        return this.dispatch('request', { method: 'post', url: 'jwt/refresh-token', data: creds })
          .then(
            response => {
              if (response === 'token_not_valid') {
                state.authenticated = false
                state.tokenJwt = ''
                state.refresh = ''
                localStorage.setItem('tokenJwt', '')
                localStorage.setItem('refresh', '')
                return 'token_not_valid'
              }
              localStorage.setItem('refresh', response.data.refresh)
              state.refresh = response.data.refresh
              localStorage.setItem('tokenJwt', response.data.access)
              state.tokenJwt = response.data.access
            }
          ).catch(error => {
            throw error
          })
      }
    },
    user ({ commit, state, dispatch }) {
      if (state.authenticated) {
        return this.dispatch('request', { method: 'get', url: 'api/user/auth' }).then(response => {
          if (response === 'token_not_valid') {
            state.authenticated = false
            state.tokenJwt = ''
            state.refresh = ''
            localStorage.setItem('tokenJwt', '')
            localStorage.setItem('refresh', '')
            return 'token_not_valid'
          }
          response.data.clients = response.data.clients.map(x => x.id)
          state.userData = response.data
          if (!localStorage.getItem('company')) {
            if (state.userData.user) {
              state.company = state.userData.user.groups[0].id
              localStorage.setItem('company', state.company)
            }
          }
          return response.data
        }).catch(error => {
          dispatch('logout').then(() => { this.$router.push('/login') })
          throw error
        })
      }
    },
    fetchCompany ({ commit, state }) {
      if (!state.company) {
        commit('SET_IS_TRW', false)
        return
      }
      return this.dispatch('request', { method: 'get', url: 'api/company', params: { id: state.company } })
        .then(response => {
          const results = response.data.results || response.data
          const isTrw = results && results.length > 0 && results[0].is_trw ? results[0].is_trw : false
          commit('SET_IS_TRW', isTrw)
        }).catch(() => { commit('SET_IS_TRW', false) })
    },
    hasPermission ({ commit, getters, state }, actionRequired) {
      return this.dispatch('auth/fetchCompany').then(() => {
        var prohibitions = new Map(getters.permisionCollection.map(x => [x.id, x.prohibitions]))
        var hasPermission = true
        if (state.userData.roles) {
          state.userData.roles.forEach(rol => {
            if (prohibitions.get(rol.id).indexOf(actionRequired) >= 0) hasPermission = false
          })
          return hasPermission
        } else {
          return this.dispatch('auth/user').then(() => {
            if (state.userData.roles) {
              state.userData.roles.forEach(rol => {
                if (prohibitions.get(rol.id).indexOf(actionRequired) >= 0) hasPermission = false
              })
            } else hasPermission = false
            return hasPermission
          })
        }
      })
    },
    hasPermissions ({ commit, getters, state }, actionsRequired) {
      return this.dispatch('auth/fetchCompany').then(() => {
        const prohibitions = new Map(getters.permisionCollection.map(x => [x.id, x.prohibitions]))
        const results = {}

        console.log(state.isTrw)

        const checkPermissions = (roles) => {
          actionsRequired.forEach(action => {
            results[action] = true
            roles.forEach(rol => {
              if (prohibitions.get(rol.id).indexOf(action) >= 0) {
                results[action] = false
              }
            })
          })
        }

        if (state.userData.roles) {
          checkPermissions(state.userData.roles)
          return Promise.resolve(results)
        } else {
          return this.dispatch('auth/user').then(() => {
            if (state.userData.roles) {
              checkPermissions(state.userData.roles)
            } else {
              // eslint-disable-next-line
              actionsRequired.forEach(action => results[action] = false)
            }
            return results
          })
        }
      })
    }
  },
  getters: {
    permisionCollection (state) {
      const roles = {
        admin: state.isTrw ? state.adminTrw : state.admin,
        office: state.isTrw ? state.officeTrw : state.office,
        warehouseResp: state.isTrw ? state.warehouseRespTrw : state.warehouseResp,
        forklift: state.isTrw ? state.forkliftTrw : state.forklift,
        kiosk: state.isTrw ? state.kioskTrw : state.kiosk,
        client: state.isTrw ? state.clientTrw : state.client,
        truckAccess: state.isTrw ? state.truckAccessTrw : state.truckAccess,
        guardia: state.guardia,
        carretilleros: state.carretilleros,
        oficinaJuanCarlos: state.oficinaJuanCarlos,
        plannerTrw: state.plannerTrw,
        kioskReceptions: state.kioskReceptions,
        provider: state.provider
      }
      return Object.values(roles)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/auth.js